module.exports = __webpack_public_path__ + "img/wind-engine.png";